import { useState } from 'react';
import { Kpi, Pnl, Money, WinBar, Pager, fmtUsd, fmtHold } from './anUi';
import { PositionsTable } from './Tables';

const PAGE_SIZE = 20;
const FILTERS = ['Tous', 'Gagnant', 'Perdant', 'En cours'];

export default function TradesTab({ d }) {
  const [filter, setFilter] = useState('Tous');
  const [page, setPage] = useState(1);

  const counts = { Gagnant: d.wins, Perdant: d.losses, 'En cours': d.openCount };
  const rows = d.positions.filter(p => filter === 'Tous' || p.resultat === filter);
  const totalPages = Math.ceil(rows.length / PAGE_SIZE);
  const paged = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="an-section">
      <div className="an-kpis an-kpis--15">
        <Kpi label="🔄 Trades" value={d.totalTrades} tip="Positions fermées (≥ 90 % revendu)" />
        <Kpi label="📆 Période" value={`${d.daysActive} jour(s)`} />
        <Kpi label="✅ Gagnants" value={d.wins} tone="pos" />
        <Kpi label="❌ Perdants" value={d.losses} tone="neg" />
        <Kpi label="⏳ En cours" value={d.openCount} tip="Positions ouvertes ou revendues à moins de 90 %" />
        <Kpi label="🎯 Win rate" value={d.totalTrades > 0 ? <WinBar value={d.winRate} /> : '—'} />
        <Kpi label="💰 Total achat" value={fmtUsd(d.totalAchatUsd)} />
        <Kpi label="💸 Total vente" value={fmtUsd(d.totalVenteUsd)} />
        <Kpi label="💵 PNL total" value={<Money value={d.totalTrades > 0 ? d.pnlUsd : null} />} />
        <Kpi label="📈 ROI moyen" value={<Pnl value={d.overallRoi} />} />
        <Kpi label="🟢 Gain moy" value={d.avgGainUsd > 0 ? fmtUsd(d.avgGainUsd) : '—'} tone="pos" />
        <Kpi label="🔴 Perte moy" value={d.avgLossUsd > 0 ? fmtUsd(d.avgLossUsd) : '—'} tone="neg" />
        <Kpi label="⚖️ R:R ratio" value={d.rrRatio != null ? d.rrRatio.toFixed(2) : '—'} tone={d.rrRatio != null ? (d.rrRatio >= 1 ? 'pos' : 'neg') : ''} />
        <Kpi label="🔥 Streak max" value={d.maxStreak > 0 ? d.maxStreak : '—'} tone="pos" />
        <Kpi label="⏱ Durée moy" value={fmtHold(d.dureeMoyMin)} />
      </div>

      <div className="an-filter-bar">
        {FILTERS.map(f => (
          <button key={f} className={`an-filter-btn${filter === f ? ' an-filter-btn--active' : ''}`} onClick={() => { setFilter(f); setPage(1); }}>
            {f}{counts[f] != null && <span className="an-filter-count">{counts[f]}</span>}
          </button>
        ))}
        <span className="an-muted an-small an-right">{rows.length} trade(s) · page {page}/{totalPages || 1}</span>
      </div>

      {paged.length === 0
        ? <p className="an-empty-inline">Aucun trade dans cette catégorie.</p>
        : <><PositionsTable rows={paged} /><Pager page={page} total={totalPages} onPage={setPage} /></>}
    </div>
  );
}
